module.exports = __webpack_public_path__ + "static/Miguel-Jimenez-77136913ef9830fec45dd7269487491c.png";